import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const removeFromStudentFavorite = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "teacher/removeFromStudentFavorite",
  async (studentId: string, { extra: { teacherRepository } }) => {
    return teacherRepository!.removeFromStudentFavorite(studentId);
  },
);

export const resetRemoveFromStudentFavorite = createAction("teacher/resetRemoveFromStudentFavorite");
